import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { withGlobalContext } from '../../App';
import './topbar.scss';

class Topbar extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.func,
    ]).isRequired,
    className: PropTypes.string,
    shrinkSidebar: PropTypes.bool,
  };

  render() {
    return (
      <div
        className={cx(
          'topbar fixed h-16 bg-white pin-t p-4 z-10',
          {
            shrink_topbar: !this.props.shrinkSidebar,
          },
          this.props.className
        )}>
        {this.props.children}
      </div>
    );
  }
}

export default  withGlobalContext(Topbar);
